import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Directory } from 'src/app/interfaces/directory';

@Injectable({
  providedIn: 'root'
})
export class SharedDirectoryToSendService {

    private directory: any[] = []
    private directoriesSubject = new BehaviorSubject(this.directory);
    sharedDirectory = this.directoriesSubject.asObservable();

    constructor() { }

    addDirectory(directory: any) {
        this.directory.push(directory);
        this.directoriesSubject.next(this.directory);
    }  

    removeDirectory(patientMail: string) {
        const index: number = this.directory.findIndex(directory => directory.email === patientMail);
        if (index !== -1) {
            this.directory.splice(index,1);
        }
        this.directoriesSubject.next(this.directory);
    }

    resetDirectory() {
        this.directory = [];
        this.directoriesSubject.next(this.directory);
    }

    getDirectory() {
        return this.directory;
    }
}
